import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled, { useTheme } from 'styled-components'

import { Span } from '@/@bothrs-ui/web/components/typography/Body'

import type { ComponentPropsWithoutRef } from 'react'

/* ------------------------------------------------------------------------------------------------- *
 * AppointmentDetail
 * ------------------------------------------------------------------------------------------------- */

type AppointmentDetailRootProps = ComponentPropsWithoutRef<'div'>

const AppointmentDetailRoot = ({ children, ...props }: AppointmentDetailRootProps) => (
  <StRoot {...props}>{children}</StRoot>
)

/* ------------------------------------------------------------------------------------------------- *
 * AppointmentDetail.Icon
 * ------------------------------------------------------------------------------------------------- */

type AppointmentDetailIconProps = ComponentPropsWithoutRef<typeof FontAwesomeIcon>

const AppointmentDetailIcon = (props: AppointmentDetailIconProps) => <StIcon {...props} />

/* ------------------------------------------------------------------------------------------------- *
 * AppointmentDetail.Date
 * ------------------------------------------------------------------------------------------------- */

type AppointmentDetailDateProps = ComponentPropsWithoutRef<typeof Span>

const AppointmentDetailDate = ({ children, ...props }: AppointmentDetailDateProps) => (
  <StText type='BodyLargeRegular' {...props}>
    {children}
  </StText>
)

/* ------------------------------------------------------------------------------------------------- *
 * AppointmentDetail.Time
 * ------------------------------------------------------------------------------------------------- */

type AppointmentDetailTimeProps = ComponentPropsWithoutRef<typeof Span>

const AppointmentDetailTime = ({ children, ...props }: AppointmentDetailTimeProps) => (
  <StText type='BodyLargeRegular' {...props}>
    {children}
  </StText>
)

/* ------------------------------------------------------------------------------------------------- *
 * AppointmentDetail.WaitTime
 * ------------------------------------------------------------------------------------------------- */

type AppointmentDetailWaitTimeProps = ComponentPropsWithoutRef<typeof Span>

const AppointmentDetailWaitTime = ({ children, ...props }: AppointmentDetailWaitTimeProps) => {
  const theme = useTheme()

  return (
    <Span type='BodyLargeRegular' color={theme.Colors.Status.Error} {...props}>
      {children}
    </Span>
  )
}

/* ------------------------------------------------------------------------------------------------- *
 * Compound export
 * ------------------------------------------------------------------------------------------------- */

const AppointmentDetail = Object.assign(AppointmentDetailRoot, {
  Icon: AppointmentDetailIcon,
  Date: AppointmentDetailDate,
  Time: AppointmentDetailTime,
  WaitTime: AppointmentDetailWaitTime,
})

export { AppointmentDetail }

/* ------------------------------------------------------------------------------------------------- *
 * Styled
 * ------------------------------------------------------------------------------------------------- */

const StRoot = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme }) => `
    gap: ${theme.UI.SpacingPx.Space6};
  `}
`

const StIcon = styled(FontAwesomeIcon)`
  width: 16px;
  height: 16px;
  color: ${({ theme }) => theme.Colors.Neutrals.Darkest};
`

const StText = styled(Span)`
  color: ${({ theme }) => theme.Colors.Neutrals.Darkest};
`
